Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-shipping-widget', function (envelope) {
        var $context = envelope.message.data.context,
            $control = $('.x-product-details-shipping-widget', $context);

        if ($control.length < 1) return;

        var control = $control.get(0);
        var model = null;
        var formData = {
            countryCode: 'GR',
            postCode: '',
            areaId: 0,
            quantity: 1,
            addCartSkusForCalculation: true,
        }

        $('.js-show-shipping-widget').fancybox({
            touch: false,
            beforeShow: function () {
                initialize();
            },
            afterShow: function () { }
        });

        control.loading = function (loading) {
            if (loading) {
                $control.addClass('x-loading');
            } else {
                $control.removeClass('x-loading');
            }
        };

        control.getModel = function() {
            control.loading(true);

            var currentProductState = Vendd.Product.Controller.getState();
            var skuId = currentProductState.selectedId;
            var skuItems = formData.addCartSkusForCalculation ? getCartProducts().map(function (e) { return { skuId: e.VariantId, quantity: e.Quantity }; }) : [];

            if (skuItems.find(function (e) { return e.skuId == skuId; })) {
                var existingSku = skuItems.find(function (e) {  return e.skuId == skuId; });
                existingSku.quantity += formData.quantity;
            } else {
                skuItems.push({ skuId: skuId,  quantity: formData.quantity });
            }

            var itemsJson = JSON.stringify(skuItems.filter(function (e) { return e.quantity; }));

            Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.GetShippingCost(formData.countryCode, formData.postCode, formData.areaId, itemsJson));
        };

        control.update = function () {
         
            model.codeLabel = $control.data('postalcode-label');
            var html = Vendd.Handlebars.parse("pdShippingWidget_A", model);
            $control.html(html);
            $('.pd-shipping-container').removeClass('hidden');
        };

        control.collectFormData = function collectFormData() {
            formData.countryCode = $('select[name="countryCode"]', $control).val();
            formData.postCode = $('input[type="text"][name="postCode"]', $control).val();
            formData.areaId = parseInt($('select[name="areaId"]', $control).val() || 0);

            var $skuQnt = $control.find('.form-row.quantity input');
            var currentProductState = Vendd.Product.Controller.getState();
          
            if (currentProductState.qty) {
                formData.quantity = parseInt(currentProductState.qty);
            } else {
                formData.quantity = 1;
            }

            var $addCartSkusForCalculationCheckbox = $control.find('.form-row #include-cart-products');
            formData.addCartSkusForCalculation = $addCartSkusForCalculationCheckbox.length && $addCartSkusForCalculationCheckbox.is(':checked') || false;

            control.showMessages(true);
        };

        control.clearFields = function clearFields(currentField) {

            var $postCodeInput = $('input[type="text"][name="postCode"]', $control);
            var $areaSelect = $('select[name="areaId"]', $control);
            var $ShippingMethodCompany = $('input[type="radio"][name="shippingMethodId-shippingCompanyId"]', $control);

            switch (currentField) {
                case 'countryCode':
                    $postCodeInput.val('');
                    $areaSelect.val(0);
                    $ShippingMethodCompany.prop('checked', false);
                    break;
                case 'postCode':
                    $areaSelect.val(0);
                    $ShippingMethodCompany.prop('checked', false);
                    break;
                case 'areaId':
                    $ShippingMethodCompany.prop('checked', false);
                    break;
            }
        };

        control.showMessages = function(success) {
            if (success) {
                $('.js-error', $control).hide();
                $('.error-wrapper', $control).hide();
            } else {
                $('.js-error', $control).show();
                $('.error-wrapper', $control).show();
            }
        };

        $control.on('change', '#include-cart-products', function () {
            control.collectFormData();

            if (formData.countryCode) control.getModel();
        });

        $control.on('change', 'select[name="countryCode"]', function () {
            control.clearFields('countryCode');

            control.collectFormData();
            control.getModel();
        });

        $control.on('keyup', '.form-row.quantity input[name="quantity"]', $.debounce(850, function () {
            control.collectFormData();

            // if user accidatally entered non-numeric fields, delete them
            $control.find('.form-row.quantity input[name="quantity"]').val(formData.quantity);

            if (formData.countryCode) control.getModel();
        }));

        $control.on('keyup', 'input[type="text"][name="postCode"]', function () {
            removeWhiteSpaces($(this));
        });

        $control.on('keyup', 'input[type="text"][name="postCode"]', $.debounce(850, function () {

            control.clearFields('postCode');

            control.collectFormData();
            control.getModel();
        }));

        $control.on('change', 'select[name="areaId"]', function () {

            control.clearFields('areaId');

            control.collectFormData();
            control.getModel();
        });

        $control.on('click', '.js-submit', function () {
            if ($('.shipping-widget-results', $control).hasClass('hidden'))
                $('.shipping-widget-results', $control).removeClass('hidden');
        });

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetShippingCostSuccess, control, function (envelope) {
            model = envelope.message.data.model;

            // prefill extra model properties from the current UI state
            model.Quantity = formData.quantity || 0;
            model.AddingCartSkusEnabled = !!getCartProducts().length;
            model.AddCartSkusForCalculation = formData.addCartSkusForCalculation;

            control.update();
            control.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetShippingCostFailed, control, function () {
            control.loading(false);
            control.showMessages(false);
        });

        function getCartProducts() {
            return Vendd.Cart.GetClientModel() && Vendd.Cart.GetClientModel().Cart.Items || [];
        }
        initialize();
        function initialize() {
            if (!model) {
                control.getModel();
            } else {
                control.update();
            }
            
        }
        
    });
});